// extracted by mini-css-extract-plugin
module.exports = {"table":"Accounts_table__3FWln","title":"Accounts_title__1DJTS","colorCell":"Accounts_colorCell__p5Jhv"};